import { render, staticRenderFns } from "./TriainingApplication.vue?vue&type=template&id=6b272923&scoped=true&"
import script from "./TriainingApplication.vue?vue&type=script&lang=js&"
export * from "./TriainingApplication.vue?vue&type=script&lang=js&"
import style0 from "./TriainingApplication.vue?vue&type=style&index=0&id=6b272923&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b272923",
  null
  
)

export default component.exports